module.exports = __webpack_public_path__ + "static/media/1.fa0fc5ad.jpg";